import React from 'react';
import { useIntl } from 'react-intl';
import messages from './intl';

import SavingBackSvg from '../../images/sending-signature-request.svg';
import SelfSignSavingBackImg from '../../images/self-sign-saving-back-to-dropbox.png';

import styles from '../../index.scss';

type SavingBackToDropboxProps = {
  filename: string,
  isSelfSign: boolean,
}

const SavingBackToDropbox = (props: SavingBackToDropboxProps) => {
  const { isSelfSign } = props;
  const intl = useIntl();
  const savingDescription = isSelfSign ? messages.selfSignsavingBack : messages.savingBack;
  const status = isSelfSign ? messages.signed : messages.inProgress;

  return (
    <div data-qa-ref="webflow-state-saving-back">
      <div className={styles.image}
        data-qa-ref="saving-back-to-dropbox-image"
      >
        {props.isSelfSign ? (
          <img
            className={styles.selfSignImage}
            src={SelfSignSavingBackImg}
            alt={intl.formatMessage(messages.sending)} />
        ) : (
          <img
            className={styles.sendingImage}
            src={SavingBackSvg}
            alt={intl.formatMessage(messages.sending)} />
        )}
      </div>
      <div
        className={styles.description}
        data-qa-ref="saving-back-to-dropbox-description"
      >
        {intl.formatMessage(savingDescription)}
      </div>
      <div
        className={styles.descriptionDetails}
        data-qa-ref="saving-back-to-dropbox-description-details"
      >
        {intl.formatMessage(messages.details, {
          filename: <span
            key="filename"
            className={styles.filename}
            data-qa-ref="saving-back-to-dropbox-filename"
          >
            {`${props.filename}(${intl.formatMessage(status)}).pdf`}
          </span>,
        })}
      </div>
    </div>
  );
};

export default SavingBackToDropbox;
